import { Navbar, Button } from 'react-bootstrap';
import { useAppContext } from 'providers/AppProvider';
import { useBreakpoints } from 'providers/BreakpointsProvider';
import classNames from 'classnames';
import NavbarBrand from 'components/navbars/nav-items/NavbarBrand';
import NavItems from 'components/navbars/nav-items/NavItems';
import NavItemsSlim from 'components/navbars/nav-items/NavItemsSlim';
import { UilBars } from '@iconscout/react-unicons';

interface NavbarTopDefaultProps {
  onToggleSidebar?: () => void;
}

const NavbarTopDefault = ({ onToggleSidebar }: NavbarTopDefaultProps) => {
  const {
    config: { navbarTopShape, navbarTopAppearance },
  } = useAppContext();
  
  const { breakpoints } = useBreakpoints();
  const isMobile = breakpoints.down('lg');

  return (
    <Navbar
      className={classNames('navbar-top fixed-top', {
        'navbar-slim': navbarTopShape === 'slim',
      })}
      expand
      variant=""
      data-navbar-appearance={navbarTopAppearance === 'darker' ? 'darker' : ''}
    >
      <div className="navbar-collapse justify-content-between">
        <div className="d-flex align-items-center">
          {/* Mobile menu toggle button */}
          {isMobile && (
            <Button
              variant="link"
              className="navbar-toggle me-3 p-0 border-0"
              onClick={onToggleSidebar}
              style={{ 
                background: 'none',
                boxShadow: 'none',
                color: 'var(--bs-navbar-color)',
              }}
            >
              <UilBars size={20} />
            </Button>
          )}
          <NavbarBrand />
        </div>

        {navbarTopShape === 'default' ? <NavItems /> : <NavItemsSlim />}
      </div>
    </Navbar>
  );
};

export default NavbarTopDefault;
